import { Button } from "@chakra-ui/react";

import EmptyState, { EmptyStateProps } from "@/common/components/EmptyState";
import { IcoUsers } from "@/common/components/Icons";
import { useSearchParam } from "@/common/hooks/useSearchParam";

export const CompanyUsersEmptyState = ({
  isLoading,
  isError,
  onRetry,
  ...rest
}: EmptyStateProps) => {
  const [featureFilter, setFeatureFilter] = useSearchParam("featureFilter");

  return (
    <EmptyState
      description={
        !isLoading &&
        featureFilter && (
          <Button
            color="dimmed"
            fontSize="sm"
            variant="link"
            onClick={() => {
              setFeatureFilter(null);
            }}
          >
            Clear flag filter
          </Button>
        )
      }
      error="Failed to load company users"
      flexGrow={1}
      icon={<IcoUsers boxSize="48px" />}
      isError={isError}
      isLoading={isLoading}
      pt="24"
      title="No users to show"
      onRetry={onRetry}
      {...rest}
    />
  );
};
